import routes from 'routes'
import 'video-react/dist/video-react.css';

function App() {
  return <>{routes}</>
}

export default App
